import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-45-sheetanshu-tyagi-guest.webp";
import ThumbImg from "../../assets/images/conversations/045.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: st-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .st-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .st-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 — HERO
  ══════════════════════════════════════ */
  .st-hero { padding-top: 60px; padding-bottom: 60px; }
  .st-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .st-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .st-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .st-hero__title.st-visible { opacity: 1; transform: translateY(0); }
  .st-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .st-hero__spotify.st-visible { opacity: 1; transform: translateY(0); }
  .st-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .st-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .st-hero__right.st-visible { opacity: 1; transform: translateY(0); }

  /* thumbnail */
  .st-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .st-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .st-yt-thumb:hover img { opacity: 0.85; }
  .st-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .st-yt-thumb__play img { width: 40px; height: 44px; }
  .st-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .st-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 — BODY
  ══════════════════════════════════════ */
  .st-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .st-body.st-visible { opacity: 1; transform: translateY(0); }
  .st-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .st-body__para:last-child { margin-bottom: 0; }

  /* ══════════════════════════════════════
     SECTION 3 — OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .st-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .st-guest.st-visible { opacity: 1; transform: translateY(0); }
  .st-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .st-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .st-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .st-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .st-inner { padding-left: 32px; padding-right: 32px; }
    .st-hero { padding-top: 32px; padding-bottom: 48px; }
    .st-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .st-hero__title { font-size: 24px; }
    .st-hero__left { gap: 16px; }
    .st-guest__title { font-size: 24px; margin-bottom: 24px; }
    .st-guest__photo-bg { width: 260px; height: 300px; }
    .st-guest__name { font-size: 24px; margin-top: 18px; }
    .st-body__para { font-size: 14px; margin-bottom: 12px; }
    .st-body { padding-bottom: 48px; }
    .st-guest { padding-bottom: 48px; }
    .st-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .st-inner { padding-left: 16px; padding-right: 16px; }
    .st-hero { padding-top: 51px; padding-bottom: 30px; }
    .st-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .st-hero__left { gap: 30px; }
    .st-hero__title { font-size: 30px; }
    .st-body__para { font-size: 16px; margin-bottom: 10px; }
    .st-guest__title { font-size: 30px; margin-bottom: 20px; }
    .st-guest__photo-bg { width: 100%; height: 386px; }
    .st-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .st-body { padding-bottom: 30px; }
    .st-guest { padding-bottom: 30px; }
    .st-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("st-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "-yqhbCBQ1Rg";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="st-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 45 Sheetanshu Tyagi"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="st-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 45 Sheetanshu Tyagi thumbnail" />
      <div className="st-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="st-hero">
      <div className="st-inner">
        <div className="st-hero__grid">
          <div className="st-hero__left">
            <h1 ref={titleRef} className="st-hero__title">
              EP 45 | Rediscovering the basics of batteries with Emo Energy | Sheetanshu Tyagi
            </h1>
            <div ref={spotifyRef} className="st-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/3SRTZdvd5lw8bgqr4pqpDZ?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 45 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="st-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="st-body">
      <div className="st-inner">
        <p className="st-body__para">
          Today, we speak with Sheetanshu Tyagi, co-founder of Emo Energy. Emo has developed Zen, a battery tech platform for net-zero solutions, boasting 100% fire safety, a swift 20-minute charge, and 120% extended battery life. Sheetanshu has a decade of expertise in the mobility sector, including roles with major OEMs like Rivian, Ather, and Ola, and is dedicated to creating a sustainable transport system for cleaner cities.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="st-guest">
      <div className="st-inner">
        <h2 className="st-guest__title">Our Guest</h2>
        <div>
          <div className="st-guest__photo-bg">
            <img src={GuestImg} alt="Sheetanshu Tyagi" />
          </div>
          <p className="st-guest__name">Sheetanshu Tyagi</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep45SheetanshuTyagi() {
  return (
    <>
      <style>{CSS}</style>
      <div className="st-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}